'use client'

import { useState } from 'react'

import { Popover } from '@/components/ui/popover'

import { EditorColorPickerContent } from './editor-color-picker-content.atom'
import { EditorColorPickerTrigger } from './editor-color-picker-trigger.atom'

export interface EditorColorPickerProps {
  currentColor?: string
  onColorSelect: (color: string) => void
  disabled?: boolean
  className?: string
}

/**
 * Color picker popover for selecting text color in the editor
 */
export const EditorColorPicker = ({
  currentColor,
  onColorSelect,
  disabled = false,
  className,
}: EditorColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleColorSelect = (color: string) => {
    onColorSelect(color)
    setIsOpen(false)
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <EditorColorPickerTrigger
        currentColor={currentColor}
        isDisabled={disabled}
        className={className}
      />
      <EditorColorPickerContent currentColor={currentColor} onColorSelect={handleColorSelect} />
    </Popover>
  )
}

EditorColorPicker.displayName = 'EditorColorPicker'
